import z from 'zod';

export const getAllServicesToSelectSchema = z.object({
  businessLineId: z.uuid().optional(),
});

export type GetAllServicesToSelectParams = z.infer<
  typeof getAllServicesToSelectSchema
>;
